import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_3 = {
  type: "button",
  class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-[15px] tw-pr-5 tw-pl-5 tw-pt-5 tw-pb-5 mt-3",
  style: {"margin-left":"2rem"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModalUsers"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_6 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_12 = { class: "tw-flex tw-gap-3" }
const _hoisted_13 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_15 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_17 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_19 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_34 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_35 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_36 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_37 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenario5",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenario5",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_50 = { class: "modal-body" }
const _hoisted_51 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_52 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_54 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("section", { slot: "pdf-content" }, null, -1)
const _hoisted_58 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_59 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_60 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_61 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_62 = { class: "table table-bordered border-0 mb-5 table-edit" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CUSTOMER INFORMATION")
  ])
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_67 = { class: "table table-bordered border-0 mb-3 table-edit" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FINANCING INFORMATION")
  ])
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-PRICE", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-TAXES", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-INSURANCE", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", null, "FLOOD-INSURANCE", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", null, "FEDERAL-TAXES", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", null, "ESTIMATE-ASSOCIATION-PAYMENT", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", null, "OTHERS-MONTHLY-PAYMENT", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", null, "TOTAL-ESTIMAL-MONTHLY-PAYMENT $", -1)
const _hoisted_77 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_78 = { class: "modal-dialog" }
const _hoisted_79 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_81 = { class: "modal-body" }
const _hoisted_82 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_84 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_86 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_88 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_89 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_90 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_92 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, "CASH MONTHLY PAYMENT ", -1)
const _hoisted_96 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_97 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleTotalTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("TITLE COMPANY")
], -1)
const _hoisted_99 = {
  class: "collapse",
  id: "collapseExampleTotalTittle"
}
const _hoisted_100 = { class: "card card-body" }
const _hoisted_101 = { class: "tw-flex tw-justify-around" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample99",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("INSPECTOR")
], -1)
const _hoisted_106 = {
  class: "collapse",
  id: "collapseExample99"
}
const _hoisted_107 = { class: "card card-body" }
const _hoisted_108 = { class: "tw-flex tw-justify-around" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, "GET IT", -1)
const _hoisted_111 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden tw-pb-[30px]" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " CUSTOMER", -1)
const _hoisted_113 = { class: "tw-px-4" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-border tw-border-b-[#545454] tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-pb-1 tw-mt-7 tw-text-left" }, " PERSONAL DATA", -1)
const _hoisted_115 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_116 = { class: "tw-w-full" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_118 = { class: "tw-w-full" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_120 = { class: "tw-w-full" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_122 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " TIA PAYMENT", -1)
const _hoisted_124 = { class: "tw-px-4" }
const _hoisted_125 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_126 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE", -1)
const _hoisted_128 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_129 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES", -1)
const _hoisted_131 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_132 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE", -1)
const _hoisted_134 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_135 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FLOOD INSURANCE", -1)
const _hoisted_137 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_138 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAXES", -1)
const _hoisted_140 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_141 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ESTIMATE ASSOCIATION PAYMENT", -1)
const _hoisted_143 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_144 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHER MONTHLY PAYMENT", -1)
const _hoisted_146 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_147 = { class: "tw-flex justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-justify-center" }
const _hoisted_148 = { class: "tw-flex tw-justify-center" }
const _hoisted_149 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_150 = { class: "tw-flex tw-justify-end" }
const _hoisted_151 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL MONTHLY PAYMENT $ ", -1)
const _hoisted_153 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_154 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.foreign)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("button", _hoisted_3, [
      _createElementVNode("img", {
        class: "tw-w-[40px] tw-mr-3",
        src: require('@/assets/Images/iconos-02.png'),
        alt: ""
      }, null, 8, _hoisted_4),
      _createTextVNode(" RECORD ")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_ctx.scenario.users)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.phonenumber]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_datepicker, {
                          "auto-apply": "",
                          class: "w-100",
                          range: "",
                          modelValue: _ctx.configDatePicker.date,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                            _ctx.changeDate
                          ],
                          placeholder: "Enter date range..."
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getScenarioUsers())),
                      class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                    }, "Filter"),
                    _createElementVNode("table", _hoisted_19, [
                      _hoisted_20,
                      (_ctx.scenario.users.results && _ctx.scenario.users.results.length > 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#exampleModal4858",
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.loadScenarios(user))
                                  }, _hoisted_24, 8, _hoisted_22)
                                ])
                              ]))
                            }), 256))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_25, _hoisted_27))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    (_ctx.scenario.userScenarios)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("table", _hoisted_37, [
                            _hoisted_38,
                            (_ctx.scenario.userScenarios.results && _ctx.scenario.userScenarios.results.length > 0)
                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.userScenarios.results, (userscenario) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(userscenario.code), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("a", {
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#exampleModalEscenario5",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                        }, _hoisted_42, 8, _hoisted_40)
                                      ])
                                    ]))
                                  }), 256))
                                ]))
                              : (_openBlock(), _createElementBlock("tbody", _hoisted_43, _hoisted_45))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.printScenario())),
                    class: "block"
                  }, [
                    _hoisted_53,
                    _createTextVNode("PRINT")
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.generateMail()))
                  }, _hoisted_56),
                  _createVNode(_component_vue3_html2pdf, {
                    "show-layout": false,
                    "float-layout": true,
                    "enable-download": false,
                    "preview-modal": false,
                    "pdf-quality": 2,
                    "pdf-format": "a4",
                    "pdf-content-width": "800px",
                    "manual-pagination": true,
                    onBeforeDownload: _cache[6] || (_cache[6] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                    ref: "html2Pdf"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_57
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  (_ctx.scenario.scenarioData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("table", _hoisted_62, [
                            _hoisted_63,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_64,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_65,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_phonenumber), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_66,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_email), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_67, [
                            _hoisted_68,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_69,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyPrice), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_70,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyTaxes.text) + "%", 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_71,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyInsurance.text) + "%", 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_72,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyFloodInsurance.text) + "%", 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_73,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.stateTaxes.text) + "%", 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_74,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.association), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_75,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.otherMontlhyPayment), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_76,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.totalMonthlyPayment
                                                            ?
                                                            _ctx.scenario.scenarioData.financial_information.totalMonthlyPayment
                                                            : 0), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _hoisted_83,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_84, [
                _hoisted_85,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "",
                  cols: "53",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                  rows: "9"
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.message]
                ])
              ])
            ]),
            _hoisted_87,
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                (_ctx.scenarioMail.file)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_90, [
                      _hoisted_91,
                      _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("button", {
                  "data-bs-dismiss": "modal",
                  class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                  disabled: _ctx.v$.scenarioMail.$invalid,
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
                }, "SEND MESSAGE", 8, _hoisted_93)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_94, [
        _hoisted_95,
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _hoisted_98,
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                      _createTextVNode(),
                      _hoisted_102,
                      _createElementVNode("button", {
                        class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                        onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                      }, "GET IT", 8, _hoisted_103)
                    ]))
                  }), 256))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _hoisted_105,
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                      _createTextVNode(),
                      _hoisted_109,
                      _hoisted_110
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_111, [
          _hoisted_112,
          _createElementVNode("div", _hoisted_113, [
            _hoisted_114,
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("div", _hoisted_116, [
                _hoisted_117,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customer.name) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_118, [
                _hoisted_119,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customer.phone) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_120, [
                _hoisted_121,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customer.email) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.email]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_122, [
          _hoisted_123,
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("table", _hoisted_125, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_126, [
                  _hoisted_127,
                  _createElementVNode("td", _hoisted_128, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyPriceTotalCash",
                      value: _ctx.financialInformation.propertyPrice,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.financialInformation.propertyPrice) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_129, [
                  _hoisted_130,
                  _createElementVNode("td", _hoisted_131, _toDisplayString(_ctx.financialInformation.propertyTaxes?.value !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyTaxes?.value)
                                        : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_132, [
                  _hoisted_133,
                  _createElementVNode("td", _hoisted_134, _toDisplayString(_ctx.financialInformation.propertyInsurance?.value !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyInsurance?.value)
                                        : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_135, [
                  _hoisted_136,
                  _createElementVNode("td", _hoisted_137, _toDisplayString(_ctx.financialInformation.propertyFloodInsurance?.value !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyFloodInsurance?.value)
                                        : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_138, [
                  _hoisted_139,
                  _createElementVNode("td", _hoisted_140, _toDisplayString(_ctx.financialInformation.stateTaxes?.value !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.stateTaxes?.value)
                                        : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_141, [
                  _hoisted_142,
                  _createElementVNode("td", _hoisted_143, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "association",
                      value: _ctx.financialInformation.association,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.financialInformation.association) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_144, [
                  _hoisted_145,
                  _createElementVNode("td", _hoisted_146, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "otherMontlhyPayment",
                      value: _ctx.financialInformation.otherMontlhyPayment,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.financialInformation.otherMontlhyPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_147, [
          _createElementVNode("button", {
            class: "tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl disabled:tw-bg-[#cfcfcf] disabled:tw-text-white",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.submitFormula('propertyTotalExample', $event)))
          }, "DONE")
        ]),
        _createElementVNode("div", _hoisted_148, [
          _createElementVNode("div", _hoisted_149, [
            _createElementVNode("div", _hoisted_150, [
              _createElementVNode("div", _hoisted_151, [
                _hoisted_152,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.totalMonthlyPayment) = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.totalMonthlyPayment]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_153, [
          _createElementVNode("button", {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.submitScenario($event))),
            disabled: !_ctx.scenarioValid,
            class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, "SAVE & REGISTER", 8, _hoisted_154)
        ])
      ])
    ])
  ]))
}